import ExportModal, { ExportModalProps } from './ExportModal'
import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { useMemo } from 'react'
import { REBATE_OFFERS_COLUMNS } from 'features/tradespend/rebateOffersColumnInfo'

export default function OfferExportModal(props: ExportModalProps) {
  const offerColumnHelper = createExportColumnHelper({
    columns: REBATE_OFFERS_COLUMNS,
  })

  const columns = useMemo(() => {
    const cols = [
      {
        title: 'Offer Details',
        elements: [
          offerColumnHelper.retrieveColumn('name'),
          offerColumnHelper.retrieveColumn('description'),
          offerColumnHelper.retrieveColumn('learn_more_url'),
          offerColumnHelper.retrieveColumn('state'),
          offerColumnHelper.retrieveColumn('scope'),
          offerColumnHelper.retrieveColumn('offer_type'),
          offerColumnHelper.retrieveColumn('valid_from'),
          offerColumnHelper.retrieveColumn('valid_to'),
          offerColumnHelper.retrieveColumn('modified'),
          offerColumnHelper.retrieveColumn('created'),
        ],
      },
      {
        title: 'Enrollment Stats',
        elements: [offerColumnHelper.retrieveColumn('total_enrollments')],
      },
      {
        title: 'Claim Stats',
        elements: [
          offerColumnHelper.retrieveColumn('total_claims'),
          offerColumnHelper.retrieveColumn('pending_validation_claims'),
          offerColumnHelper.retrieveColumn('invalid_claims'),
          offerColumnHelper.retrieveColumn('paid_claims'),
          offerColumnHelper.retrieveColumn('unpaid_valid_claims'),
          offerColumnHelper.retrieveColumn('total_validated_units'),
          offerColumnHelper.retrieveColumn('total_validated_payout'),
        ],
      },
    ]
    return cols
  }, [])

  return (
    <ExportModal
      title="Select Columns for Offers Download"
      subTitle="Download up to 10,000 offers at a time, with any of the following columns. Any filters already applied will remain active."
      submitText="Export Offers"
      columns={columns}
      {...props}
    />
  )
}
